<template>
  <div class="box">
    <Header :active="active" />
    <Banner />

    <div class="list">
      <div class="inner">
        <!-- <div style="margin-bottom: 20px">
          首页><span class="titles">大儒工作坊</span>
        </div> -->
        <div class="forlist clearfix">
          <div class="ym">{{ team.title }}</div>
          <div class="fish">{{ team.fabuTime }}</div>
          <div class="ol" v-html="team.content"></div>
        </div>
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Map from "../components/map.vue";
export default {
  components: {
    Header,
    Right,
    Banner,
    Map,
  },
  data() {
    return {
      active: 4,
      team: null,
    };
  },
  computed: {},
  created() {
    document.documentElement.scrollTop = 0;
    this.team = JSON.parse(sessionStorage.getItem("job"));
  },
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  mounted() {},
  methods: {},
};
</script>

<style  scoped>
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
}
.imglist img {
  display: block;
  width: 230px;
  height: 107px;
  margin-right: 20px;
  float: left;
  margin-bottom: 20px;
}
.imglist > img:nth-child(5n) {
  margin-right: 0;
}
.foot {
  line-height: 50px;
  background-color: #898989;
  text-align: center;
  color: #fff;
}
.list {
  padding: 25px 0 50px 0;
}
.titles {
  color: #2c87ce;
}
.forlist {
  margin-top: 36px;
}
.ym {
  font-size: 24px;
  text-align: center;
}
.fish {
  color: #747474;
  margin: 18px auto;
  text-align: right;
  width: 1000px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #555555;
}
.ol {
  width: 1000px;
  margin: 20px auto;
  line-height: 30px;
  text-align: justify;
}
</style>